/**
 * OCTOPUS Dashboard - FASE 3: Widget Library
 * Index - Exporta todos os componentes de widgets
 */

export { default as GaugeRadial } from './GaugeRadial';
export { default as GaugeLinear } from './GaugeLinear';
export { default as GaugeRudder } from './GaugeRudder';
export { default as NumericDisplay } from './NumericDisplay';
export { default as TextDisplay } from './TextDisplay';
export { default as CompassRose } from './CompassRose';
export { default as PositionDisplay } from './PositionDisplay';
export { default as BooleanIndicator } from './BooleanIndicator';
export { default as DataChart } from './DataChart';
export { default as MapView } from './MapView';

// Mapeamento de nome de componente para componente React
export const WIDGET_COMPONENTS = {
  GaugeRadial: require('./GaugeRadial').default,
  GaugeLinear: require('./GaugeLinear').default,
  GaugeRudder: require('./GaugeRudder').default,
  NumericDisplay: require('./NumericDisplay').default,
  TextDisplay: require('./TextDisplay').default,
  CompassRose: require('./CompassRose').default,
  PositionDisplay: require('./PositionDisplay').default,
  BooleanIndicator: require('./BooleanIndicator').default,
  DataChart: require('./DataChart').default,
  MapView: require('./MapView').default,
};

// Função helper para obter componente pelo nome
export const getWidgetComponent = (componentName) => {
  return WIDGET_COMPONENTS[componentName] || null;
};
